import { fg } from '@atlaskit/platform-feature-flags/fg';

export const INTENT_DETECTION_OPERATION_NAME = 'KnowledgeDiscoveryIntentDetectionQuery';

// exported for tests
export const BookmarkIntentFragment = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;

// exported for tests
export const PersonsIntentFragment = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;

export const ElsDetectionMetadataFragment = `
	originalIntent
	elsTraceId
	prefilterEntities {
		entityType
		id
		name
		mention
		confidenceScore
		clarificationLevel
	}
`;

// exported for tests
export const NavContentIntentFragment = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;

// using a function instead of a string literal to allow for conditional fragments
// using FGs at the module level can cause issues(always evaluates to false) with async FG evaluations
export const getIntentDetectionGQLQuery = (): string => `
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
						${fg('kd_fe_persons_intent_detection_els') ? ElsDetectionMetadataFragment : ''}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${fg('kd_enable_sain_hero_nav') ? NavContentIntentFragment : ''}
						${fg('kd_bookmark_query_intent') ? BookmarkIntentFragment : ''}
						${fg('kd_fe_persons_intent_detection_els') ? PersonsIntentFragment : ''}
					}
				}
			}
		}
	}
`;
